import * as React from "react";
import { forwardRef } from "react";
const SvgUserFilledIcon = (props, ref) => /* @__PURE__ */ React.createElement("svg", { id: "a6cf817a-0093-4c07-a48e-4452ffe0388b", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 36 43.2", width: "1em", height: "1em", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M18,21.6A10.8,10.8,0,1,0,7.2,10.8,10.79,10.79,0,0,0,18,21.6ZM32.14,43.2A3.86,3.86,0,0,0,36,39.34V36A10.81,10.81,0,0,0,25.2,25.2H23.86a14,14,0,0,1-11.72,0H10.8A10.81,10.81,0,0,0,0,36v3.34A3.86,3.86,0,0,0,3.86,43.2Z", style: {
  fill: "currentColor",
  fillRule: "evenodd"
} }));
const ForwardRef = forwardRef(SvgUserFilledIcon);
export default ForwardRef;
